import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { Title } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components";

export const StyledHeaderTitle = styled(Title)`
    ${InfoIcon} {
        line-height: unset;
    }
`;

export const ChartContainer: any = styled.div`
    box-sizing: border-box;
    padding-top: 15px;
    width: 100%;
`;

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 200px;
`;

const BoxContainer: any = styled(Box)`
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
`;

export const TotalVisitsGrowthBoxContainer: any = styled(BoxContainer)`
    margin-bottom: 1.4rem;
    padding: 0px 24px;
`;

const TrafficOverTimeBoxContainer: any = styled(BoxContainer)``;

export const TitleContainer = styled(FlexRow)`
    box-sizing: border-box;
    padding: 0px 24px 12px 0px;
    justify-content: space-between;
`;
